import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import axios from "axios";
import React, { useState, useEffect } from "react";
import StripePayment from "../../assets/images/stripe.png";

const PaymentForm = (props) => {
  // console.log(props);
  const [success, setSuccess] = useState(props.body.amount !== 0 ? false : true);
  const stripe = useStripe();
  const [isLoading, setIsLoading] = useState(false);
  const elements = useElements();

  useEffect(() => {
    const sendAdInfo = async () => {
      const response = await axios.post(props.url, {
        ...props.body,
      });
      if (response.data.success) {
        setSuccess(true);
      } else {
        alert(response.data.message);
      }
    }
    if (props.body.amount === 0) {
      sendAdInfo()
    }

  }, [props])


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });

    if (!error) {
      try {
        const { id } = paymentMethod;
        const response = await axios.post(props.url, {
          id,
          ...props.body,
        });
        if (response.data.success) {
          setSuccess(true);
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        alert(error.message);
      }
    } else {
      alert(error.message);
    }
    setIsLoading(false);
  };

  return (
    <div className="bg-white p-12 rounded">
      {!success ? (
        <div>
          {props.skipline && (
            <div className="self-center md:w-96 text-center mb-6 text-md">
              {props.body.numberOfSkipline < 8 ? (
                <p>
                  Your song has been successfully added to the queue; you are #
                  {props.body.index + 1} in line, pay to skip to the front of
                  the line and be the one of the first artists to compete!
                </p>
              ) : (
                <p>
                  Your song has been successfully added to the queue; you are #
                  {props.body.index + 1} in line, pay to skip to the front of
                  the next line and be the one of the first artists to compete!
                </p>
              )}
            </div>
          )}
          <div className="my-5 bg-white">
            <fieldset className="FormGroup">
              <div className="FormRow">
                {/* options={CARD_OPTIONS} */}
                <CardElement />
              </div>
            </fieldset>
          </div>
          <div className="flex justify-center items-center text-center">
            <button
              className="bg-blue-600 text-white rounded lg:px-8 px-6 py-1.5 mt-3 text-md"
              onClick={handleSubmit}
            >
              {isLoading ? "Loading..." : "Pay"}
            </button>
          </div>
          <div className="flex flex-wrap justify-center items-center text-center mt-12">
            <img className="w-96" src={StripePayment} alt="Stripe" />
          </div>
        </div>
      ) : (
        <div className="text-black self-center md:w-96 text-center text-md">
          <p>{props.message}</p>
        </div>
      )}
    </div>
  );
};

export default PaymentForm;
